import React, { useState, useEffect } from 'react';
import { Box, Grid, Card, CardContent, Typography, CircularProgress,  } from '@mui/material';
import {
  Store as StoreIcon,
  CardMembership as SubscribersIcon,
  Payment as PaymentIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import client from '../../api/client';

const StatCard = ({ title, value, icon, color, onClick }) => (
  <Card
    sx={{
      cursor: onClick ? 'pointer' : 'default',
      '&:hover': onClick ? { transform: 'scale(1.02)', transition: '0.2s' } : {},
    }}
    onClick={onClick}
  >
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Box
          sx={{
            p: 1.5,
            borderRadius: 2,
            bgcolor: `${color}.light`,
            color: `${color}.main`,
            ml: 2,
          }}
        >
          {icon}
        </Box>
        <Typography variant="body2" color="text.secondary">
          {title}
        </Typography>
      </Box>
      <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
        {value}
      </Typography>
    </CardContent>
  </Card>
);

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await client.get('/users/admin/shops/');
      const shops = response.data.results || [];
      
      setStats({
        totalShops: response.data.total_count || shops.length,
        subscribers: shops.filter(s => s.is_subscribed).length,
        activeShops: shops.filter(s => s.is_active).length,
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold' }}>
        داشبورد
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard
            title="کل پرده فروشی‌ها"
            value={stats?.totalShops || 0}
            icon={<StoreIcon />}
            color="primary"
            onClick={() => navigate('/admin/shops')}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard
            title="مشترکین فعال"
            value={stats?.subscribers || 0}
            icon={<SubscribersIcon />}
            color="success"
            onClick={() => navigate('/admin/subscribers')}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard
            title="پرداخت‌ها"
            value="—"
            icon={<PaymentIcon />}
            color="warning"
            onClick={() => navigate('/admin/payments')}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminDashboard;
